import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Icon from '@mdi/react';
import { mdiLinkedin } from '@mdi/js';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';


const AboutPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.AboutPageData.edges[0]
  console.log(data, locale);
  return (
      <Layout>

        <Helmet>
          <html lang={locale === 'en' ? 'en' : 'de'} />
          <title>
            { 
              locale === 'en' ?
                'About - presono' :
                'Über - presono'
            }
          </title>
          <meta
            name="description"
            content={ 
              locale === 'en' ?
                'Founded in Linz in 2015, the StartUp completely rethinks the subject of presentation and combines professional presentation and perfect management in a revolutionary software solution! ' :
                'Das 2015 in Linz gegründete StartUp denkt das Thema Präsentation komplett neu und verbindet professionelles Präsentieren und perfektes Managen in einer revolutionären Software!'
            }
          />
        </Helmet>

        <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />

        <section className="solutions about">
        <div className="solutions-header">
            <section className="headliner top ">
              <div className="container">

              </div>
            </section>
          </div>
          <section className="headliner starfield t2 pusher">
            <div className="container">
              <div class="column">
                <ReactMarkdown source={data.frontmatter.headline} />
              </div>
            </div>
          </section>
          <section className="customers">
            <div className="container">
              <div className="columns">
                  <div className="column is-full logos2">
                    <div className="columns">
                      <div class="inner">
                        <ReactMarkdown source={data.frontmatter.companyMessage} />
                      </div>
                    </div>
                  </div>
              </div>
              <div className="columns">
                <div className="column is-one-third">
                  <div className="card">
                    <div className="card-content">
                      <div className="media">
                        <div className="media-content">
                          <p className="title is-4">{data.frontmatter.presonoAge}</p>
                          <p><span class="underline">{ locale === "en" ? "Years old" : "Jahre alt"}</span></p>
                        </div>
                      </div>
                      <div className="content">
                      { locale === "en" ? "presono was founded in 2015" : "presono wurde 2015 von den"}<br />
                      { locale === "en" ? "by the 3 co-founders in Linz." : "3 Co-Foundern in Linz gegründet."}<br />&nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column is-one-third">
                  <div className="card">
                    <div className="card-content">
                      <div className="media">
                        <div className="media-content">
                          <p className="title is-4">3</p>
                          <p><span class="underline">{ locale === "en" ? "Founders" : "Gründer"}</span></p>
                        </div>
                      </div>
                      <div className="content">
                        Hannes Freudenthaler, Martin Behrens und<br /> Martin Luftensteiner<br />&nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column is-one-third">
                  <div className="card">
                    <div className="card-content">
                      <div className="media">
                        <div className="media-content">
                          <p className="title is-4">{data.frontmatter.count}</p>
                          <p><span class="underline">{ locale === "en" ? "Employees" : "Mitarbeiter*innen"}</span></p>
                        </div>
                      </div>
                      <div className="content">
                        { locale === "en" ? "In the meantime the team has" : "Mittlerweile ist das Team von den 3"}<br /> { locale === "en" ? "grown from the 3 founders to a stately size" : "Gründern zu einer stattlichen Größe von " + data.frontmatter.count }<br /> { locale === "en" ? "of "+ data.frontmatter.count +"." : "angewachsen."}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/*
          <section className="headliner more-blogs">
            <div className="container">
              <div class="column">
              <ReactMarkdown source={data.frontmatter.teamHeadline} />
                <p class="spacer">
                  <ReactMarkdown source={data.frontmatter.teamHeadlineSubtext} />
                </p>
                <div className="columns">
                  <div className="column is-one-third">
                    <div className="card">
                      <div className="card-image">
                        <figure className="image team is-4by3" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.lukasFoto.relativePath})` }}>
                        </figure>
                      </div>
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">Lukas Keller</p>
                          </div>
                        </div>
                        <div className="content">
                          <p className="about-p">{data.frontmatter.lukasText}</p>
                          <p className="left-nav">CEO</p>
                          <p className="right-nav">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/lukaskeller/">
                              <Icon path={mdiLinkedin}
                                size={1}
                                color="#95B0BE"
                                />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="column is-one-third">
                    <div className="card">
                      <div className="card-image">
                        <figure className="image team is-4by3" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.martinFoto.relativePath})` }}>
                        </figure>
                      </div>
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">Martin Behrens</p>
                          </div>
                        </div>
                        <div className="content">
                          <p className="about-p">{data.frontmatter.martinText}</p>
                          <p className="left-nav">COO</p>
                          <p className="right-nav">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/martinbehrens90/">
                              <Icon path={mdiLinkedin}
                                size={1}
                                color="#95B0BE"
                                />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="column is-one-third">
                    <div className="card">
                      <div className="card-image">
                        <figure className="image team is-4by3" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.sebastianFoto.relativePath})` }}>
                        </figure>
                      </div>
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">Sebastian Gierlinger</p>
                          </div>
                        </div>
                        <div className="content">
                          <p className="about-p">{data.frontmatter.sebastianText}</p>
                          <p className="left-nav">CTO</p>
                          <p className="right-nav">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/sgierlinger/">
                              <Icon path={mdiLinkedin}
                                size={1}
                                color="#95B0BE"
                                />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <Link class="button is-rounded customers-button" to="/contact">{data.frontmatter.teamButton}</Link>
                </div>
              </div>
            </div>
          </section>
          */}
        </section>
        <Newsletter newsletter={data.frontmatter} locale={locale} />
        <Footer locale={locale} />
      </Layout>
  )
}

export default AboutPage;

AboutPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query AboutContent($locale: String) {
  AboutPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_about"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          headline
          companyMessage
          presonoAge
          count
          teamHeadline
          teamHeadlineSubtext
          lukasText
          lukasFoto {
            name
            relativePath
          }
          martinText
          martinFoto {
            name
            relativePath
          }
          sebastianText
          sebastianFoto {
            name
            relativePath
          }
          teamButton
          langSwitch
        }
      }
    }
  }
}
`;
